import {Box, Button} from '@mantine/core';
import {useCallback, useMemo} from 'react';
import {AvatarInterface, generateRandomAvatar, useCreateAvatar} from '../hooks/useCreateAvatar';

interface ActionsProps {
    currentAvatar: AvatarInterface,
    temporaryAvatar: AvatarInterface,
    setTemporaryAvatar: (avatar: AvatarInterface) => void,
}

export function AvatarEditActions({currentAvatar, temporaryAvatar, setTemporaryAvatar}: ActionsProps) {
    const {publishAvatar} = useCreateAvatar();

    const isModified = useMemo(() => {
        return JSON.stringify(currentAvatar) === JSON.stringify(temporaryAvatar);
    }, [currentAvatar, temporaryAvatar]);

    const handleApply = useCallback(() => {
        publishAvatar(temporaryAvatar);
    }, [temporaryAvatar, publishAvatar]);

    const handleCancel = useCallback(() => {
        setTemporaryAvatar(currentAvatar);
    }, [currentAvatar, setTemporaryAvatar]);

    const handleRandom = useCallback(() => {
        const randomAvatar = generateRandomAvatar();
        setTemporaryAvatar(randomAvatar);
    }, [generateRandomAvatar, setTemporaryAvatar]);

    return (
        <Box style={{position: 'absolute', bottom: '8%', left: '50%', pointerEvents: 'initial', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: '15px'}}>
            <Button name='apply' onClick={() => handleApply()} disabled={isModified}>Apply</Button>
            <Button name='cancel' onClick={() => handleCancel()} disabled={isModified}>Cancel</Button>
            <Button name='random' onClick={() => handleRandom()}>Random</Button>
        </Box>
    );
}
